(function() {
  var pricing = document.querySelector('#landsman-package .ufc-package-card__pricing[data-landsman-dual="true"]');
  if (!pricing) return;
  var btn = pricing.querySelector('.ufc-package-cta');
  var priceEl = pricing.querySelector('[data-landsman-price="current"]');
  var compareEl = pricing.querySelector('[data-landsman-price="compare"]');
  var variantCut = pricing.getAttribute('data-variant-id-cutting');
  var variantMass = pricing.getAttribute('data-variant-id-mass');
  var priceCut = pricing.getAttribute('data-price-cutting');
  var priceMass = pricing.getAttribute('data-price-mass');
  var compareCut = pricing.getAttribute('data-compare-cutting') || '';
  var compareMass = pricing.getAttribute('data-compare-mass') || '';
  var mainDishCut = pricing.getAttribute('data-main-dish-count-cutting') || '';
  var mainDishMass = pricing.getAttribute('data-main-dish-count-mass') || '';

  function applyGoal(goal) {
    var isMass = (goal === 'mass');
    var vid = isMass ? variantMass : variantCut;
    var price = isMass ? priceMass : priceCut;
    var compare = isMass ? compareMass : compareCut;
    var mainDish = isMass ? mainDishMass : mainDishCut;
    if (btn && vid) btn.setAttribute('data-variant-id', vid);
    if (btn && mainDish) {
      btn.setAttribute('data-main-dish-count', mainDish);
      var meta = document.querySelector('meta[name="box-main-dish-count"]');
      if (meta) meta.setAttribute('content', mainDish);
    }
    if (priceEl && price) priceEl.textContent = price;
    if (compareEl) {
      if (compare) { compareEl.textContent = compare; compareEl.style.display = ''; }
      else compareEl.style.display = 'none';
    }
  }

  function syncFromStorage() {
    try {
      var goal = (typeof localStorage !== 'undefined' && localStorage.getItem('landsman_selected_goal')) || 'cutting';
      applyGoal(goal);
    } catch (e) { applyGoal('cutting'); }
  }

  syncFromStorage();
  document.addEventListener('landsman:goal-changed', function(e) {
    if (e.detail && e.detail.goal) applyGoal(e.detail.goal);
    else syncFromStorage();
  });
})();
